import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Quiz } from '../models';
import { PaginationParams } from '../types';

export const quizzesActions = createActionGroup({
    source: 'Quizzes',
    events: {
        'Get Quizzes': props<{ value: PaginationParams }>(),
        'Get Quizzes Success': props<{ payload: Quiz[]; total: number }>(),
        'Get Quizzes Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
